<p-sidebar [(visible)]="rightMenuActive" position="right" [blockScroll]="true" [baseZIndex]="1000"
    [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" [showCloseIcon]="false">
    <div class="flex flex-column">
        <div class="flex justify-content-between align-items-center">
            <h5 class="pt-3">{{translation_service.getText('lbl_notifications')}}</h5>
            <div class="flex" >
                <button *ngIf="count > 0" pButton pRipple type="button" icon="pi pi-cog" class="p-button-rounded p-button-text p-button"
                    pTooltip="Actions" tooltipPosition="top" (click)="option.toggle($event)"></button>
                <button pButton pRipple type="button" icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger" (click)="close()"></button>
                <p-overlayPanel #option *ngIf="count > 0">
                    <ng-template pTemplate>
                        <div class="grid grid-nogutter flex-column gap-5 w-15rem">
                            <div class="col-12 flex flex-column">
                                <span class="flex align-items-center cursor-pointer hover:surface-hover transition-duration-150 transition-all py-2" (click)="notificationReadAll()">
                                    <i class="pi pi-check mr-2"></i>
                                    {{translation_service.getText('lbl_mark_all_as_read')}}
                                </span>
                                
                                <span class="flex align-items-center cursor-pointer hover:surface-hover transition-duration-150 transition-all py-2" (click)="notificationUnreadAll()">
                                    <i class="pi pi-ban mr-2"></i>
                                    {{translation_service.getText('lbl_mark_all_as_unread')}}
                                </span>
                                
                                <span class="flex align-items-center cursor-pointer hover:surface-hover transition-duration-150 transition-all py-2" (click)="onDelete()">
                                    <i class="pi pi-trash mr-2"></i>
                                    {{translation_service.getText('lbl_delete_all')}}
                                </span>
                            </div>
                        </div>
                    </ng-template>
                </p-overlayPanel>
            </div>
        </div>
        <div *ngIf="unread_count > 0" class="text-center">
            <span>{{translation_service.getText('lbl_you_have')}} <b>{{unread_count}}</b>
                {{translation_service.getText('lbl_unread_notifications')}}</span>
        </div>
    </div>
    <hr>
    <ul class="list-none p-0 overflow-auto " style="max-height: 558px;scrollbar-width: thin;" infiniteScroll
        [infiniteScrollDistance]="scroll_distance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
        (scrolled)="onScroll()">
        <ng-container *ngFor="let group of notification_list">
            <ng-container *ngFor="let notification of group.notifications">
                <li (mouseenter)="toggleOptions($event, options)" (mouseleave)="toggleOptions($event, options)"
                    class="mt-4 hover:surface-hover transition-colors border-radius transition-duration-150">
                    <div class="flex p-2" style="align-items: center;">
                        <i *ngIf="!notification.is_read" class="pi pi-circle cursor-pointer"
                            (click)="notificationRead(notification.notification_id, true)"></i>
                        <i *ngIf="notification.is_read" class="pi pi-check-circle cursor-pointer text-green-600"
                            (click)="notificationRead(notification.notification_id, false)"></i>
                        <img [src]="notification.profile_image" alt="avatar"
                            style="width: 3rem; height: 3rem; border-radius: 50%; margin-left: 0.5rem;" />

                        <div style="flex: 1; margin-left: 1rem;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span
                                    style="font-size: small; font-weight: bold;">{{notification.created_by_name}}</span>
                                <small class="text-gray-dark ">{{notification.formatted_date}}</small>
                            </div>
                            <div style="margin-top: 0.5rem;">
                                <span style="font-size: small;">{{notification.title}}</span><br />
                                <span style="font-size: small; line-height: 1.5;">{{notification.message}}</span>
                            </div>
                        </div>

                        <div style="visibility: hidden;" #options>
                            <button pButton pRipple icon="pi pi-times" class="p-button-danger p-button-lg p-button-text"
                                [ngStyle]="{ 'transform': 'scale(0.8)' }"
                                (click)="notificationDelete($event, notification.notification_id)" pTooltip="Delete"
                                tooltipPosition="top" type="button"></button>
                        </div>
                    </div>
                </li>
            </ng-container>
        </ng-container>
    </ul>

    <div class="d-flex flex-column align-items-center h-100 py-5" style="margin-top: 18rem;"
        *ngIf="count == 0">
        <div class="text-center">
            <div>
                <button pButton pRipple type="button" icon="pi pi-truck"
                    class="mx-auto text-primary-500 bg-primary-100 rounded-full dark:bg-gray-800 border border-primary-100 mb-1"></button>
            </div>
            {{translation_service.getText('lbl_notifications_not_found')}}
        </div>
    </div>
</p-sidebar>